import axiosInstance from "../services/axiosInstance";

export const registerUser = async (userData) => {
    const response = await axiosInstance.post("/api/auth/register", userData);
    return response.data;
};

export const testBackend = async () => {
    const response = await axiosInstance.get("/");
    return response.data;
};

export const loginUser = async (userData) => {
    const response = await axiosInstance.post("/api/auth/login", userData);
    return response.data;
};

export const loginWithGoogle = async (authCode) => {
    const response = await axiosInstance.post("/api/auth/google", { authCode });
    return response.data;
};

export const getUserProfile = async () => {
    const response = await axiosInstance.get("/api/auth/profile");
    return response.data;
};

export const logoutUser = async () => {
    const response = await axiosInstance.post("/api/auth/logout");
    return response.data;
};
